export default {
  base: {
    position: 'absolute',
    bottom: '0'
  },

  nonAbsolute: {
    textAlign: 'left'
  },

  action: {
    textDecoration: 'underline'
  }
}
